/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * Creates a page footer
 */
function enerveeFooterDirective() {
    return {
        // must be an element (can not be used as an attribute or ...)
        restrict: 'E',
        scope: {},
        controller: enerveeFooterController,
        template: require('./footerView.html'),
    };
}

enerveeFooterController.$inject = [
    '$scope',
    'FooterService',
    'NavLinksService'
];

function enerveeFooterController(
    $scope,
    FooterService,
    NavLinksService
) {
    var _faqLink = NavLinksService.getErrorPageFAQLink();
    FooterService.getFooterLinks().then(function (links) {
        $scope.links = links;
    });
    $scope.trackNavEngagement = FooterService.trackNavEngagement;

    /**
     * Helper function to determine if the link is to a support
     * page.
     *
     * @param {String} href
     * @return {Boolean}
     */
    var isSupportLink = function (href) {
        var containsSupport = href.indexOf('/support/') !== -1;
        var isFAQLink = href === _faqLink;
        return isFAQLink || containsSupport;
    };

    /**
     * Utility method for handling when a link is clicked on. This is
     * to allow us to fire off a tracking event under certain
     * conditions (support links for now).
     */
    $scope.handleLinkClick = function (e) {
        var _isSupportLink = isSupportLink(e.target.href);
        if (_isSupportLink) {
            NavLinksService.handleFAQLinkClick(e);
        } else {
            NavLinksService.trackLinkAndReClick(e, {
                eventAction: 'ClickedLinkFooter',
                attributes: {
                    pageSection: 'Footer',
                }
            });
        }
    };
}

module.exports = enerveeFooterDirective;
